<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="card min-height">
      <div class="card-body">
        <div class="px-4 pb-4">
          <div class="row">
            <div class="col-3">
              <h2 class="card-title-desc">Sample Orders</h2>
            </div>
          </div>
          <div class="row mb-4">
            <div class="col-6" v-if="isUserStaff()">
              <button v-if="httpLoading" class="btn btn-dark me-1" :disabled="httpLoading">Loading</button>
              <div v-else class="d-flex">
                <date-picker v-model="reportSelectedDate" range class="me-3" placeholder="Select Dates to Generate Report"></date-picker>
                <button class="btn btn-info me-1 w-100" @click="downloadSampleOrdersReport">Download Sample Orders Report</button>
              </div>
            </div>
          </div>
          <TableLoading v-if="sampleOrders.page === 0"/>
          <div v-else>
            <data-table :columns="columns" :rows="sampleOrders.objects" :current-page="currentPage" :has-pagination="false" @onSearch="searchFn">
              <template v-slot:actions="slotProps">
                <div class="button-items" v-if="checkForPermission(view_single_order_sample_permission)">
                  <b-button variant="info" size="sm" class="py-1 text-white" @click="viewSampleDetails(slotProps.row.publicId)">
                    View Details
                  </b-button>
                  <b-button v-if="slotProps.row.status.orderStatusName === 'Open'" variant="danger" size="sm" class="py-1 text-white" @click="customizeSampleOrder(slotProps.row.publicId)">
                    Customize Order
                  </b-button>
                </div>
              </template>
              <div class="row mb-2">
                <div class="col-3">
                  <div class="flex-nowrap input-group mb-3">
                    <label class="input-group-text bg-primary text-white">Delivery Date</label>
                    <date-picker v-model="selectedDate"  range @change="deliveryDateFilter"></date-picker>
                  </div>
                </div>
              </div>
            </data-table>
            <b-pagination
                v-model="currentPage"
                :total-rows="sampleOrders.total"
                :per-page="perPage"
                size="lg"
                align="center"
                class="mt-3"
            />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "@/router/layouts/main"
import PageHeader from "@/components/page-header";
import {routeItems} from "@/router/endpoints";
import DataTable from "@/components/data-table";
import {ALL_SAMPLE_ORDERS} from "@/gql/orders";
import TableLoading from "@/components/TableLoading";
import {permissions} from "@/router/permissions";
import {getDatesInRange} from "@/filters/datesInRange";
import {mapActions, mapGetters} from "vuex";
import moment from "moment/moment";
import {downloadFileConfig} from "@/filters/downloadFileConfig";
import {errorToast} from "@/components/successToast";
export default {
  page: {
    title: "Sample Orders",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {TableLoading, DataTable, PageHeader, Layout},
  name: "sample-orders",
  data() {
    return {
      title: "Sample Orders",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Sample Orders",
          active: true
        }
      ],
      columns: [
        {
          field: 'orderedBy',
          label: 'Ordered By'
        },
        {
          field: 'invoiceId',
          label: 'Order'
        },
        {
          field: 'createdAt',
          label: 'Order Date'
        },
        {
          field: 'deliveryDate',
          label: 'Delivery Date'
        },
        {
          field: 'productCount',
          label: 'Total Products'
        },
        {
          field: 'orderStatus',
          label: 'Status'
        },
        {
          field: 'actions',
          label: 'Actions'
        }
      ],
      view_single_order_sample_permission: permissions.view_single_order_sample_permission,
      reportSelectedDate: "",
      deliveryDates: [],
      sampleOrders: {
        page: 0,
        objects: []
      },
      currentPage: 1,
      perPage: 30,
      searchKeyword: "",
      selectedDate: "",
    }
  },
  apollo: {
    sampleOrders: {
      query: ALL_SAMPLE_ORDERS,
      variables(){
        return {
          page: this.currentPage,
          perPage: this.perPage,
          searchKeyword: this.searchKeyword,
          deliveryDates: this.deliveryDates
        }
      }
    }
  },
  watch: {
    currentPage(){
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }
  },
  computed: {
    ... mapGetters({
      httpLoading: 'http/httpLoading',
      httpErrors: 'http/httpErrors'
    })
  },
  mounted() {
    this.currentPage = parseInt(this.$route.query.page) || 1
  },
  methods: {
    ... mapActions({
      generateSampleOrdersReport: 'http/generateSampleOrdersReport',
    }),
    viewSampleDetails(public_id){
      this.$router.push({path: routeItems.sample_invoice_route+'/'+public_id, query: {keyword: this.searchKeyword}}).catch()
    },
    customizeSampleOrder(public_id){
      this.$router.push({path: routeItems.customize_sample_order_route+'/'+public_id, query: {keyword: this.searchKeyword}}).catch()
    },
    searchFn(data){
      this.searchKeyword = data
    },
    deliveryDateFilter(){
      if(this.selectedDate[0] === null){
        this.deliveryDates = []
      }else{
        this.deliveryDates = getDatesInRange(this.selectedDate[0], this.selectedDate[1])
      }
    },
    async downloadSampleOrdersReport(){
      if (this.reportSelectedDate !== ''){
        const start = moment(this.reportSelectedDate[0]).format('YYYY-MM-DD')
        const end = moment(this.reportSelectedDate[1]).format('YYYY-MM-DD')
        const response = await this.generateSampleOrdersReport({'start': start, 'end': end})
        if(response.data.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"){
          downloadFileConfig(response, `Sample Orders ${start} - ${end} Report.xlsx`)
        }else {
          errorToast('Error generating sample orders report')
        }
      }else {
        errorToast('Date selection cannot be blank')
      }
    }

  }
}
</script>

<style scoped>

</style>
